import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { useCallback, useState } from 'react';
import { useNotificationsContext, useTransactionsContext } from '../providers';
import { BigNumber, errors } from 'ethers';
import { buildSafeTransaction, getLatestNonce } from '../helpers/gnosisSafeUtils';
import { useEthers } from './useEthers';
import { waitForSafeTransaction } from '../helpers/gnosisSafeUtils';
import { useGnosisSafeContract } from './useGnosisSafeContract';
/**
 * @internal
 */
export function estimateTransactionGasLimit(_x, _x2, _x3) {
  return _estimateTransactionGasLimit.apply(this, arguments);
}
/**
 * @internal
 */
function _estimateTransactionGasLimit() {
  _estimateTransactionGasLimit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(transactionRequest, signer, gasLimitBufferPercentage) {
    var estimatedGas;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!(!signer || !transactionRequest)) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return", undefined);
        case 2:
          _context4.prev = 2;
          if (!transactionRequest.gasLimit) {
            _context4.next = 7;
            break;
          }
          _context4.t0 = BigNumber.from(transactionRequest.gasLimit);
          _context4.next = 10;
          break;
        case 7:
          _context4.next = 9;
          return signer.estimateGas(transactionRequest);
        case 9:
          _context4.t0 = _context4.sent;
        case 10:
          estimatedGas = _context4.t0;
          return _context4.abrupt("return", estimatedGas === null || estimatedGas === void 0 ? void 0 : estimatedGas.mul(gasLimitBufferPercentage + 100).div(100));
        case 14:
          _context4.prev = 14;
          _context4.t1 = _context4["catch"](2);
          console.error(_context4.t1);
          return _context4.abrupt("return", undefined);
        case 18:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 14]]);
  }));
  return _estimateTransactionGasLimit.apply(this, arguments);
}
export function estimateContractFunctionGasLimit(_x4, _x5, _x6, _x7) {
  return _estimateContractFunctionGasLimit.apply(this, arguments);
}
/**
 * @internal
 */
function _estimateContractFunctionGasLimit() {
  _estimateContractFunctionGasLimit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(contractWithSigner, functionName, args, gasLimitBufferPercentage) {
    var _contractWithSigner$e, estimatedGas, gasLimit;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (_contractWithSigner$e = contractWithSigner.estimateGas)[functionName].apply(_contractWithSigner$e, _toConsumableArray(args));
        case 3:
          estimatedGas = _context5.sent;
          gasLimit = estimatedGas === null || estimatedGas === void 0 ? void 0 : estimatedGas.mul(gasLimitBufferPercentage + 100).div(100);
          return _context5.abrupt("return", gasLimit);
        case 8:
          _context5.prev = 8;
          _context5.t0 = _context5["catch"](0);
          console.error(_context5.t0);
          return _context5.abrupt("return", undefined);
        case 12:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 8]]);
  }));
  return _estimateContractFunctionGasLimit.apply(this, arguments);
}
function isNonContractWallet(_x8, _x9) {
  return _isNonContractWallet.apply(this, arguments);
}
function _isNonContractWallet() {
  _isNonContractWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(library, address) {
    var code;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          if (!(!library || !address)) {
            _context6.next = 2;
            break;
          }
          return _context6.abrupt("return", true);
        case 2:
          _context6.next = 4;
          return library.getCode(address);
        case 4:
          code = _context6.sent;
          return _context6.abrupt("return", code === '0x');
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _isNonContractWallet.apply(this, arguments);
}
var isDroppedAndReplaced = function isDroppedAndReplaced(e) {
  return (e === null || e === void 0 ? void 0 : e.code) === errors.TRANSACTION_REPLACED && (e === null || e === void 0 ? void 0 : e.replacement) && ((e === null || e === void 0 ? void 0 : e.reason) === 'repriced' || (e === null || e === void 0 ? void 0 : e.cancelled) === false);
};
export function usePromiseTransaction(chainId, options) {
  var _useState = useState({
      status: 'None',
      transactionName: options === null || options === void 0 ? void 0 : options.transactionName
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useTransactionsConte = useTransactionsContext(),
    addTransaction = _useTransactionsConte.addTransaction,
    updateTransaction = _useTransactionsConte.updateTransaction;
  var _useNotificationsCont = useNotificationsContext(),
    addNotification = _useNotificationsCont.addNotification;
  var _useEthers = useEthers(),
    library = _useEthers.library,
    account = _useEthers.account;
  var gnosisSafe = useGnosisSafeContract(account, library);
  var resetState = useCallback(function () {
    setState(function (_ref) {
      var transactionName = _ref.transactionName;
      return {
        status: 'None',
        transactionName: transactionName
      };
    });
  }, [setState]);
  var promiseTransaction = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(transactionPromise) {
      var _ref3,
        safeTransaction,
        transactionRequest,
        _a,
        _b,
        _c,
        _d,
        _e,
        _f,
        _g,
        _h,
        _j,
        _k,
        _l,
        _m,
        _o,
        _p,
        _q,
        _r,
        _s,
        _t,
        _u,
        _v,
        _w,
        handleNonContractWallet,
        handleContractWallet,
        transaction,
        isContractWallet,
        result,
        _result,
        parsedErrorCode,
        errorCode,
        errorHash,
        errorMessage,
        droppedAndReplaced,
        status,
        type,
        _args3 = arguments;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _ref3 = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, safeTransaction = _ref3.safeTransaction;
            transactionRequest = _args3.length > 2 ? _args3[2] : undefined;
            handleNonContractWallet = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(transaction) {
                var receipt;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (chainId) {
                        _context.next = 2;
                        break;
                      }
                      return _context.abrupt("return");
                    case 2:
                      setState(function (_ref5) {
                        var transactionName = _ref5.transactionName;
                        return {
                          transactionName: transactionName,
                          transaction: transaction,
                          status: 'Mining'
                        };
                      });
                      addTransaction({
                        transaction: Object.assign(Object.assign({}, transaction), {
                          chainId: chainId
                        }),
                        submittedAt: Date.now(),
                        transactionName: options === null || options === void 0 ? void 0 : options.transactionName
                      });
                      _context.next = 6;
                      return transaction.wait();
                    case 6:
                      receipt = _context.sent;
                      updateTransaction({
                        transaction: Object.assign(Object.assign({}, transaction), {
                          chainId: chainId
                        }),
                        receipt: receipt,
                        transactionName: options === null || options === void 0 ? void 0 : options.transactionName
                      });
                      setState({
                        receipt: receipt,
                        transaction: transaction,
                        status: 'Success',
                        chainId: chainId,
                        transactionName: options === null || options === void 0 ? void 0 : options.transactionName
                      });
                      return _context.abrupt("return", {
                        transaction: transaction,
                        receipt: receipt
                      });
                    case 10:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function handleNonContractWallet(_x11) {
                return _ref4.apply(this, arguments);
              };
            }();
            handleContractWallet = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(transactionPromise) {
                var _ref7,
                  safeTransaction,
                  _a,
                  gnosisSafeContract,
                  latestNonce,
                  safeTx,
                  _yield$waitForSafeTra,
                  transaction,
                  receipt,
                  rejected,
                  errorMessage,
                  _args2 = arguments;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _ref7 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, safeTransaction = _ref7.safeTransaction;
                      if (!(!chainId || !library || !account)) {
                        _context2.next = 3;
                        break;
                      }
                      return _context2.abrupt("return");
                    case 3:
                      setState({
                        status: 'CollectingSignaturePool',
                        chainId: chainId,
                        transactionName: options === null || options === void 0 ? void 0 : options.transactionName
                      });
                      gnosisSafeContract = gnosisSafe.get();
                      if (gnosisSafeContract) {
                        _context2.next = 7;
                        break;
                      }
                      throw new Error("Couldn't create Gnosis Safe contract instance");
                    case 7:
                      _context2.next = 9;
                      return getLatestNonce(chainId, account);
                    case 9:
                      latestNonce = _context2.sent;
                      _context2.t0 = buildSafeTransaction;
                      _context2.t1 = (_a = safeTransaction === null || safeTransaction === void 0 ? void 0 : safeTransaction.to) !== null && _a !== void 0 ? _a : '';
                      _context2.t2 = safeTransaction === null || safeTransaction === void 0 ? void 0 : safeTransaction.value;
                      _context2.t3 = safeTransaction === null || safeTransaction === void 0 ? void 0 : safeTransaction.data;
                      _context2.t4 = safeTransaction === null || safeTransaction === void 0 ? void 0 : safeTransaction.safeTxGas;
                      if (!latestNonce) {
                        _context2.next = 19;
                        break;
                      }
                      _context2.t5 = latestNonce + 1;
                      _context2.next = 22;
                      break;
                    case 19:
                      _context2.next = 21;
                      return gnosisSafeContract.nonce();
                    case 21:
                      _context2.t5 = _context2.sent;
                    case 22:
                      _context2.t6 = _context2.t5;
                      _context2.t7 = {
                        to: _context2.t1,
                        value: _context2.t2,
                        data: _context2.t3,
                        safeTxGas: _context2.t4,
                        nonce: _context2.t6
                      };
                      safeTx = (0, _context2.t0)(_context2.t7);
                      _context2.next = 27;
                      return waitForSafeTransaction(transactionPromise, gnosisSafeContract, chainId, safeTx);
                    case 27:
                      _yield$waitForSafeTra = _context2.sent;
                      transaction = _yield$waitForSafeTra.transaction;
                      receipt = _yield$waitForSafeTra.receipt;
                      rejected = _yield$waitForSafeTra.rejected;
                      if (rejected) {
                        errorMessage = 'On-chain rejection created';
                        addTransaction({
                          transaction: Object.assign(Object.assign({}, transaction), {
                            chainId: chainId
                          }),
                          receipt: receipt,
                          submittedAt: Date.now(),
                          transactionName: options === null || options === void 0 ? void 0 : options.transactionName
                        });
                        setState({
                          status: 'Fail',
                          transaction: transaction,
                          receipt: receipt,
                          errorMessage: errorMessage,
                          chainId: chainId,
                          transactionName: options === null || options === void 0 ? void 0 : options.transactionName
                        });
                      } else {
                        addTransaction({
                          transaction: Object.assign(Object.assign({}, transaction), {
                            chainId: chainId
                          }),
                          receipt: receipt,
                          submittedAt: Date.now(),
                          transactionName: options === null || options === void 0 ? void 0 : options.transactionName
                        });
                        setState({
                          receipt: receipt,
                          transaction: transaction,
                          status: 'Success',
                          chainId: chainId,
                          transactionName: options === null || options === void 0 ? void 0 : options.transactionName
                        });
                      }
                      return _context2.abrupt("return", {
                        transaction: transaction,
                        receipt: receipt
                      });
                    case 33:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function handleContractWallet(_x12) {
                return _ref6.apply(this, arguments);
              };
            }();
            if (chainId) {
              _context3.next = 6;
              break;
            }
            return _context3.abrupt("return");
          case 6:
            transaction = undefined;
            _context3.prev = 7;
            if (options === null || options === void 0 ? void 0 : options.enablePendingSignatureNotification) {
              setState({
                status: 'PendingSignature',
                chainId: chainId,
                transactionName: options === null || options === void 0 ? void 0 : options.transactionName
              });
              addNotification({
                notification: {
                  type: 'transactionPendingSignature',
                  submittedAt: Date.now(),
                  transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
                  transactionRequest: transactionRequest
                },
                chainId: chainId
              });
            }
            _context3.next = 11;
            return isNonContractWallet(library, account);
          case 11:
            isContractWallet = !_context3.sent;
            if (!isContractWallet) {
              _context3.next = 20;
              break;
            }
            _context3.next = 15;
            return handleContractWallet(transactionPromise, {
              safeTransaction: safeTransaction
            });
          case 15:
            result = _context3.sent;
            transaction = result === null || result === void 0 ? void 0 : result.transaction;
            return _context3.abrupt("return", result === null || result === void 0 ? void 0 : result.receipt);
          case 20:
            _context3.next = 22;
            return transactionPromise;
          case 22:
            transaction = _context3.sent;
            _context3.next = 25;
            return handleNonContractWallet(transaction);
          case 25:
            _result = _context3.sent;
            transaction = _result === null || _result === void 0 ? void 0 : _result.transaction;
            return _context3.abrupt("return", _result === null || _result === void 0 ? void 0 : _result.receipt);
          case 28:
            _context3.next = 38;
            break;
          case 30:
            _context3.prev = 30;
            _context3.t0 = _context3["catch"](7);
            parsedErrorCode = parseInt((_g = (_e = (_c = (_b = (_a = _context3.t0.error) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : (_d = _context3.t0.error) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : (_f = _context3.t0.data) === null || _f === void 0 ? void 0 : _f.code) !== null && _g !== void 0 ? _g : _context3.t0.code);
            errorCode = isNaN(parsedErrorCode) ? undefined : parsedErrorCode;
            errorHash = (_l = (_k = (_j = (_h = _context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.error) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.originalError) === null || _k === void 0 ? void 0 : _k.data) !== null && _l !== void 0 ? _l : (_m = _context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.error) === null || _m === void 0 ? void 0 : _m.data;
            errorMessage = (_v = (_t = (_s = (_q = (_p = (_o = _context3.t0.error) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.message) !== null && _q !== void 0 ? _q : (_r = _context3.t0.error) === null || _r === void 0 ? void 0 : _r.message) !== null && _s !== void 0 ? _s : _context3.t0.reason) !== null && _t !== void 0 ? _t : (_u = _context3.t0.data) === null || _u === void 0 ? void 0 : _u.message) !== null && _v !== void 0 ? _v : _context3.t0.message;
            if (transaction) {
              droppedAndReplaced = isDroppedAndReplaced(_context3.t0);
              if (droppedAndReplaced) {
                status = _context3.t0.receipt.status === 0 ? 'Fail' : 'Success';
                type = status === 'Fail' ? 'transactionFailed' : 'transactionSucceed';
                addNotification({
                  notification: {
                    type: type,
                    submittedAt: Date.now(),
                    transaction: _context3.t0.replacement,
                    receipt: _context3.t0.receipt,
                    transactionName: (_w = _context3.t0.replacement) === null || _w === void 0 ? void 0 : _w.transactionName,
                    originalTransaction: transaction
                  },
                  chainId: chainId
                });
                setState(function (prevState) {
                  var _a;
                  return Object.assign(Object.assign({}, prevState), {
                    status: status,
                    transaction: _context3.t0.replacement,
                    originalTransaction: transaction,
                    receipt: _context3.t0.receipt,
                    transactionName: (_a = _context3.t0.replacement) === null || _a === void 0 ? void 0 : _a.transactionName,
                    errorMessage: errorMessage,
                    errorCode: errorCode,
                    errorHash: errorHash,
                    chainId: chainId
                  });
                });
              } else {
                setState({
                  status: 'Fail',
                  transaction: transaction,
                  receipt: _context3.t0.receipt,
                  errorMessage: errorMessage,
                  errorCode: errorCode,
                  errorHash: errorHash,
                  chainId: chainId,
                  transactionName: options === null || options === void 0 ? void 0 : options.transactionName
                });
              }
            } else {
              setState({
                status: 'Exception',
                errorMessage: errorMessage,
                errorCode: errorCode,
                errorHash: errorHash,
                chainId: chainId,
                transactionName: options === null || options === void 0 ? void 0 : options.transactionName
              });
            }
            return _context3.abrupt("return", undefined);
          case 38:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[7, 30]]);
    }));
    return function (_x10) {
      return _ref2.apply(this, arguments);
    };
  }(), [chainId, addNotification, options === null || options === void 0 ? void 0 : options.transactionName, library, account]);
  return {
    promiseTransaction: promiseTransaction,
    state: state,
    resetState: resetState
  };
}